import { render, staticRenderFns } from "./PieceOfMemory.vue?vue&type=template&id=73a8c698&"
import script from "./PieceOfMemory.vue?vue&type=script&lang=js&"
export * from "./PieceOfMemory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports